import { render, staticRenderFns } from "./EstablishmentDetail.vue?vue&type=template&id=95ec1ade&scoped=true&"
import script from "./EstablishmentDetail.vue?vue&type=script&lang=js&"
export * from "./EstablishmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./EstablishmentDetail.vue?vue&type=style&index=0&id=95ec1ade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ec1ade",
  null
  
)

component.options.__file = "EstablishmentDetail.vue"
export default component.exports